import styled from 'styled-components';

export const AdminContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 120px 20px 40px;
  font-family: var(--font-primary);
`;

export const AdminHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--color-light-gray);
`;

export const AdminTitle = styled.h1`
  font-family: var(--font-heading);
  font-weight: var(--font-weight-light);
  font-size: 2.2rem;
  color: var(--color-text);
`;

export const AdminButton = styled.button`
  background-color: var(--color-text);
  color: white;
  border: 1px solid var(--color-text);
  padding: 10px 20px;
  cursor: pointer;
  font-family: var(--font-primary);
  font-size: 0.9rem;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: white;
    color: var(--color-text);
  }
  
  &:disabled {
    background-color: var(--color-light-gray);
    color: var(--color-dark-gray);
    border-color: var(--color-light-gray);
    cursor: not-allowed;
  }
`;

export const AdminCard = styled.div`
  border: 1px solid var(--color-light-gray);
  padding: 20px;
  margin-bottom: 20px;
  transition: box-shadow 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
  margin-top: 20px;
`;

export const ProjectCard = styled.div`
  border: 1px solid var(--color-light-gray);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  }
`;

export const ProjectImageContainer = styled.div`
  height: 200px;
  overflow: hidden;
  position: relative;
`;

export const ProjectImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  
  ${ProjectCard}:hover & {
    transform: scale(1.05);
  }
`;

export const ProjectInfo = styled.div`
  padding: 15px;
`;

export const ProjectTitle = styled.h3`
  font-family: var(--font-heading);
  font-weight: var(--font-weight-light);
  font-size: 1.2rem;
  margin-bottom: 5px;
`;

export const ProjectLocation = styled.p`
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  margin-bottom: 10px;
`;

export const ProjectActions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const FormLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: var(--font-weight-medium);
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid var(--color-light-gray);
  font-family: var(--font-primary);
  font-size: 1rem;
  margin-top: 5px;
  
  &:focus {
    outline: none;
    border-color: var(--color-text);
  }
`;

export const FormTextarea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid var(--color-light-gray);
  font-family: var(--font-primary);
  font-size: 1rem;
  margin-top: 5px;
  min-height: 120px;
  
  &:focus {
    outline: none;
    border-color: var(--color-text);
  }
`;

export const FormSelect = styled.select`
  width: 100%;
  padding: 10px;
  border: 1px solid var(--color-light-gray);
  font-family: var(--font-primary);
  font-size: 1rem;
  margin-top: 5px;
  
  &:focus {
    outline: none;
    border-color: var(--color-text);
  }
`;

export const FormCheckbox = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  
  input {
    margin-right: 10px;
  }
`;

export const ErrorMessage = styled.div`
  color: #e74c3c;
  font-size: 0.9rem;
  margin-top: 5px;
`;

export const SuccessMessage = styled.div`
  color: #2ecc71;
  font-size: 0.9rem;
  margin-top: 5px;
`;

export const ImagePreviewContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
`;

export const ImagePreview = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  border: 1px solid var(--color-light-gray);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  button {
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    border: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 12px;
    
    &:hover {
      background: rgba(0, 0, 0, 0.9);
    }
  }
`;

export const FileUploadContainer = styled.div`
  border: 2px dashed var(--color-light-gray);
  padding: 20px;
  text-align: center;
  margin-top: 10px;
  cursor: pointer;
  transition: border-color 0.3s ease;
  
  &:hover {
    border-color: var(--color-text);
  }
  
  input[type="file"] {
    display: none;
  }
`;

export const TabsContainer = styled.div`
  margin-bottom: 20px;
`;

export const TabButton = styled.button<{ $isActive: boolean }>`
  background: ${props => props.$isActive ? 'var(--color-text)' : 'white'};
  color: ${props => props.$isActive ? 'white' : 'var(--color-text)'};
  border: 1px solid var(--color-text);
  padding: 10px 20px;
  margin-right: 10px;
  cursor: pointer;
  font-family: var(--font-primary);
  transition: all 0.3s ease;
  
  &:hover {
    background: ${props => props.$isActive ? 'var(--color-text)' : 'rgba(0, 0, 0, 0.05)'};
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 4px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--color-text-secondary);
  
  &:hover {
    color: var(--color-text);
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;

export const KeyPointsContainer = styled.div`
  margin-top: 10px;
`;

export const KeyPointItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  
  input {
    flex-grow: 1;
    margin-right: 10px;
  }
  
  button {
    background: none;
    border: none;
    color: #e74c3c;
    cursor: pointer;
  }
`;

export const AddButton = styled.button`
  background: none;
  border: 1px solid var(--color-text);
  color: var(--color-text);
  padding: 5px 10px;
  cursor: pointer;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
  
  span {
    margin-right: 5px;
  }
`;

// Styles pour la section de galerie détaillée
export const DetailGallerySection = styled.div`
  margin-top: var(--spacing-lg);
  padding-top: var(--spacing-md);
  border-top: 1px solid var(--color-light-gray);
`;

export const DetailGalleryTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: var(--spacing-md);
  font-family: var(--font-primary);
  font-weight: var(--font-weight-light);
  letter-spacing: 1px;
`;

export const DetailGalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-md);
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const DetailImageCard = styled.div`
  position: relative;
  border: 1px solid var(--color-light-gray);
  padding: var(--spacing-sm);
  border-radius: 4px;
`;

export const DetailImagePreview = styled.img`
  width: 100%;
  aspect-ratio: 4/3;
  object-fit: cover;
  margin-bottom: var(--spacing-xs);
`;

export const DetailImageCaption = styled.input`
  width: 100%;
  padding: var(--spacing-xs);
  border: 1px solid var(--color-light-gray);
  border-radius: 4px;
  font-size: 0.9rem;
  margin-bottom: var(--spacing-xs);
`;

export const DetailImageActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DragHandle = styled.div`
  cursor: grab;
  padding: var(--spacing-xs);
  
  &:active {
    cursor: grabbing;
  }
`;

export const DetailImageUploadContainer = styled.div`
  border: 2px dashed var(--color-light-gray);
  padding: var(--spacing-md);
  text-align: center;
  border-radius: 4px;
  margin-bottom: var(--spacing-md);
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: var(--color-light-gray);
  }
`;

export const DetailImageUploadText = styled.p`
  color: var(--color-dark-gray);
  margin-bottom: var(--spacing-sm);
`;

// Styles pour la section de détails du projet
export const ProjectDetailsSection = styled.div`
  margin-top: var(--spacing-lg);
  border-top: 1px solid var(--color-light-gray);
  padding-top: var(--spacing-md);
`;

export const ProjectDetailsSectionTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: var(--spacing-md);
  font-weight: var(--font-weight-medium);
`;

export const ProjectDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-md);
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ProjectDetailCard = styled.div`
  border: 1px solid var(--color-light-gray);
  padding: var(--spacing-md);
  border-radius: 4px;
  position: relative;
`;

export const ProjectDetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-sm);
`;

export const ProjectDetailTitle = styled.h4`
  font-size: 1rem;
  margin: 0;
  font-weight: var(--font-weight-medium);
`;

export const ProjectDetailType = styled.span`
  font-size: 0.8rem;
  padding: 2px 8px;
  background-color: var(--color-light-gray);
  border-radius: 4px;
  color: var(--color-dark-gray);
`;

export const ProjectDetailValue = styled.p`
  font-size: 0.9rem;
  margin: var(--spacing-xs) 0;
`;

export const ProjectDetailActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-xs);
  margin-top: var(--spacing-sm);
`;

export const ProjectDetailForm = styled.div`
  margin-top: var(--spacing-md);
  padding: var(--spacing-md);
  border: 1px solid var(--color-light-gray);
  border-radius: 4px;
  background-color: #f9f9f9;
`;
